'use es6';

import ActionTypes from '../actions/ActionTypes';
export const initialWizardState = {
  selectedCategoryGroup: undefined,
  selectedCategory: undefined,
  onlyShowCertificateCourses: false,
  currentStep: 1,
  isToolsSelected: false,
  selectedToolsGroup: undefined,
  selectedTool: undefined,
  isBannerExpanded: false,
  dontShowAgainInitial: undefined,
  isWizardCompleted: false,
  isProgressPanelExpanded: false,
  savedResults: null
};
export function Wizard(state = initialWizardState, action) {
  switch (action.type) {
    case ActionTypes.WIZARD_SET_DONT_SHOW_AGAIN_INITIAL:
      {
        return Object.assign({}, state, {
          dontShowAgainInitial: action.payload.dontShowAgainInitial
        });
      }
    case ActionTypes.WIZARD_SET_TOOLS_SELECTED:
      {
        return Object.assign({}, state, {
          isToolsSelected: true
        });
      }
    case ActionTypes.WIZARD_SET_TOOLS_UNSELECTED:
      {
        return Object.assign({}, state, {
          isToolsSelected: false
        });
      }
    case ActionTypes.WIZARD_SET_SELECTED_TOOLS_GROUP:
      {
        return Object.assign({}, state, {
          selectedToolsGroup: action.payload.selectedToolGroup
        });
      }
    case ActionTypes.WIZARD_SET_SELECTED_TOOL:
      {
        return Object.assign({}, state, {
          selectedTool: action.payload.selectedTool
        });
      }
    case ActionTypes.WIZARD_SET_SELECTED_CATEGORY_GROUP:
      {
        return Object.assign({}, state, {
          selectedCategoryGroup: action.payload.selectedCategoryGroup
        });
      }
    case ActionTypes.WIZARD_SET_SELECTED_CATEGORY:
      {
        return Object.assign({}, state, {
          selectedCategory: action.payload.selectedCategory
        });
      }
    case ActionTypes.WIZARD_SET_ONLY_SHOW_CERTIFICATE_COURSES:
      {
        return Object.assign({}, state, {
          onlyShowCertificateCourses: action.payload.onlyShowCertificateCourses
        });
      }
    case ActionTypes.WIZARD_SET_CURRENT_STEP:
      {
        return Object.assign({}, state, {
          currentStep: action.payload.currentStep
        });
      }
    case ActionTypes.WIZARD_SET_PROGRESS_PANEL_EXPANDED:
      {
        return Object.assign({}, state, {
          isProgressPanelExpanded: action.payload.expanded
        });
      }
    case ActionTypes.WIZARD_SET_BANNER_EXPANDED:
      {
        return Object.assign({}, state, {
          isBannerExpanded: true
        });
      }
    case ActionTypes.WIZARD_SET_RESULTS:
      {
        return Object.assign({}, state, {
          savedResults: action.payload.savedResults
        });
      }
    case ActionTypes.WIZARD_SET_COMPLETED:
      {
        return Object.assign({}, state, {
          isWizardCompleted: true
        });
      }
    default:
      return state;
  }
}
export default Wizard;